import { SxProps, Theme } from '@mui/material';

export const stylesCreateNewFolderFormGridContainer: SxProps<Theme> = {
  height: '100%',
};

export const stylesCreateNewFolderGridItem: SxProps<Theme> = {
  height: '100%',
};

export const stylesCreateNewFolderCard: SxProps<Theme> = {
  mt: 2,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
};

export const stylesCreateNewFolderCardSubheader: SxProps<Theme> = {
  fontWeight: 'fontWeightRegular',
  mt: 2,
};

export const stylesCreateNewFolderCardContent: SxProps<Theme> = {
  flex: 1,
  overflow: 'auto',
};

export const stylesCreateNewFolderFormSubtitle: SxProps<Theme> = {
  fontWeight: 'fontWeightRegular',
  color: 'primary.main',
  pb: 2,
};

export const stylesPreFolderQualificationPage = {
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: '0',
  left: '0',
  px: 4,
  py: 3,
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'grey.100',
};
export const stylesLanguageBar = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
};
export const stylesLanguage = {
  marginRight: 2,
};
export const stylesPreFolderQualification = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  p: 4,
  mt: 3,
  backgroundColor: '#FFF',
};
export const stylesPreFolderQualificationText = {
  fontWeight: 'fontWeightMedium',
  mb: 2,
};
export const stylesPreFolderQualificationWarning = {
  color: 'warning.main',
  fontStyle: 'italic',
};
export const stylesFolderTypologyChoices = {
  flex: 1,
  display: 'flex',
  mt: 4,
  gap: 4,
  flexWrap: 'wrap',
  flexDirection: 'row-reverse',
  // flexDirection: 'row',
  // height: '100%',
  // justifyContent: 'space-evenly',
  // padding: '24px',
  // ':last:child': {
  //   marginRight: 0,
  // },
};
export const stylesCloseModalButton = {
  position: 'absolute',
  top: '16px',
  right: '16px',
  minWidth: 'initial',
  '.MuiSvgIcon-colorError': {
    fontSize: '9px',
  },
};
export const stylesErrorMessageBox = {
  position: 'relative',
  mt: 3,
};
export const stylesErrorMessagesTitle = {
  fontSize: 'bodySM.fontSize',
  fontWeight: 'fontWeightMedium',
};
export const stylesErrorMessagesText = {
  fontSize: 'bodyXS.fontSize',
  a: {
    color: 'primary.main',
  },
};

export const stylesCreateNewRequestFormSubtitle: SxProps<Theme> = {
  fontWeight: 'fontWeightRegular',
  color: 'primary.main',
  pb: 2,
};

export const stylesAutoCompleteSingleSelect = {
  '&.MuiAutocomplete-root .MuiAutocomplete-inputRoot': {
    padding: '0px !important',
  },
};
